var map = {
	"./墨江哈尼族自治县.json": "171e",
	"./孟连傣族拉祜族佤族自治县.json": "7c88",
	"./宁洱哈尼族彝族自治县.json": "ba33",
	"./思茅区.json": "1d61",
	"./景东彝族自治县.json": "c594",
	"./景谷傣族彝族自治县.json": "b455",
	"./江城哈尼族彝族自治县.json": "437f",
	"./澜沧拉祜族自治县.json": "7ae3",
	"./西盟佤族自治县.json": "6579",
	"./镇沅彝族哈尼族拉祜族自治县.json": "2c23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "669b";